import utils from './utils';

import carousel from './components/carousel';
import menu from './components/menu';
import imgtosvg from './components/imgtosvg';
import lazyload from './components/lazy-load';
import accordion from './components/accordion';
import map from './components/map';

function initHiPriorityCommon() {
    imgtosvg.initImgtosvg();
	lazyload.init();
}

function initLowPriorityCommon() {
    setTimeout(function() {
        
    }, 1000);
}

function initPage() {
    carousel.initCarousel();
    menu.initMenu();
    accordion.init();
    map.initGoogleMap();
}

// document.addEventListener( 'DOMContentLoaded', function () {
utils.domReady(function () {
	initHiPriorityCommon();
	initPage();
	initLowPriorityCommon();
});

window.addEventListener('load', function () {
    //loadScript('https://cdn.iubenda.com/iubenda.js', false, null);
    //injectsmxConsole();
});